export const paymentMode = {
  CC: 'Credit Card/Debit Card',
  CH: 'Cash/Cheque'
}
